export const PLACEHOLDERS = {
  DATE: 'dd/mm/yyyy',
  DATE_LOCAL: 'dd/mm/yyyy --:--'
};
